import React from "react";

import {
  CalendarIcon,
  DegreeIcon,
  DotSeparatorIcon,
  PackageIcon,
  TransitionArrowIcon,
} from "../../icons";
import {
  getGraduationYear,
  getPlacedMonthMeta,
  getShortenedDegree,
} from "../../utils/reviewUtils";

import "./PlacedStudentCard.css";

export default function PlacedStudentCard({ review }) {
  const { year } = getPlacedMonthMeta(review);
  const studentName = review["Stundent Name"];
  const profileUrl = review["Student profile image Url"];
  const packageLpa = review["Package in lpa"];
  const graduationYear = getGraduationYear(review);
  const shortenedDegree = getShortenedDegree(review);
  const companyLogoUrl = review["Company logo Url"];

  return (
    <div className="placed-student-card keen-slider__slide">
      <div className="card-frst-cont">
        <div className="image-8128822519 w-embed">
          <img
            src={profileUrl}
            alt={`${studentName} profile`}
            loading="lazy"
            width="100%"
          />
        </div>
        <div className="div-block-1831980521448570">
          <h3 className="heading-3671140">{studentName}</h3>
          <div className="div-block-1831980521448569">
            <div className="month-cont">
              <CalendarIcon />
              <div className="div-block-1831980521448618">
                <div className="month-text svg-308">{review["Placed Month"]}</div>
                <div className="text-block-941288240427"> &apos; </div>
                <div className="month-text">{String(year).slice(-2)}</div>
              </div>
            </div>
            <DotSeparatorIcon />
            <div className="month-cont">
              <PackageIcon />
              <div className="div-block-1831980521448619">
                <div className="month-text">{packageLpa}</div>
                <div className="month-text"> LPA</div>
              </div>
            </div>
            <DotSeparatorIcon />
            <div className="month-cont">
              <DegreeIcon />
              <div className="div-block-1831980521448618">
                <div className="month-text svg-308">{graduationYear}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card-sec-cont placed-card-transition">
        <div className="div-block-1831980521448571 placed-card-transition__before">
          <div className="text-block-941288240428">Before</div>
          <div className="text-block-941288240429">{shortenedDegree}</div>
        </div>
        <div className="placed-card-transition__arrow" aria-hidden="true">
          <TransitionArrowIcon />
        </div>
        <div className="div-block-1831980521448572 placed-card-transition__after">
          <div className="text-block-941288240428">After</div>
          <div className="image-8128822520 w-embed">
            <img src={companyLogoUrl} alt={`${review["Company Name"]} logo`} loading="lazy" height="100%" />
          </div>
        </div>
      </div>
    </div>
  );
}
